"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSlider = void 0;
var _reactSlider = _interopRequireDefault(require("react-slider"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SliderMixin = require("../../mixins/components/SliderMixin");
var StyledSlider = /*#__PURE__*/(0, _styledComponents.default)(_reactSlider.default).withConfig({
  displayName: "StyledSlider",
  componentId: "c11n-8-107-0__sc-15y3zdh-0"
})(["", ""], _SliderMixin.SliderMixin);
exports.StyledSlider = StyledSlider;